(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[959],{

/***/ 53353:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
var APP_ID = "";
function setAppId(id) {
    if (id) {
        APP_ID = id;
    }
}
exports.setAppId = setAppId;
function updateIntercom(event, settings) {
    if (event === void 0) { event = "update"; }
    if (settings === void 0) { settings = null; }
    if (typeof window !== "undefined" && window.Intercom) {
        window.Intercom("update", settings);
    }
}
exports.updateIntercom = updateIntercom;
function createIntercomSSR(appId) {
    if (appId === void 0) { appId = APP_ID; }
    return __awaiter(this, void 0, void 0, function () {
        var dataSource, scriptBody, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4, fetch("https://widget.intercom.io/widget/" + appId)];
                case 1:
                    dataSource = _a.sent();
                    return [4, dataSource.text()];
                case 2:
                    scriptBody = _a.sent();
                    return [2, "<script type=\"text/javascript\" async=\"true\">" + scriptBody + "</script>"];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [2, error_1];
                case 4: return [2];
            }
        });
    });
}
exports.createIntercomSSR = createIntercomSSR;
function loadIntercom(_a) {
    var _b = _a.appId, appId = _b === void 0 ? APP_ID : _b, _c = _a.ssr, ssr = _c === void 0 ? false : _c, callBack = _a.callBack, _d = _a.delay, delay = _d === void 0 ? 0 : _d, _e = _a.email, email = _e === void 0 ? null : _e, name = _a.name, _f = _a.initWindow, initWindow = _f === void 0 ? true : _f, _g = _a.scriptType, scriptType = _g === void 0 ? "async" : _g, _h = _a.scriptInitDelay, scriptInitDelay = _h === void 0 ? 0 : _h, extra = __rest(_a, ["appId", "ssr", "callBack", "delay", "email", "name", "initWindow", "scriptType", "scriptInitDelay"]);
    setAppId(appId);
    if (ssr) {
        return createIntercomSSR(appId);
    }
    else if (typeof window !== "undefined") {
        if (typeof window.Intercom === "function") {
            updateIntercom("reattach_activator");
            updateIntercom("update", window.intercomSettings);
        }
        else if (typeof document !== "undefined") {
            var intercomeBase = function () {
                intercomeBase.c(arguments);
            };
            intercomeBase.q = [];
            intercomeBase.c = function (args) {
                intercomeBase.q.push(args);
            };
            window.Intercom = intercomeBase;
            var loadScript = function () {
                var intercomLoaded = document.querySelector("script[src=\"" + ("https://widget.intercom.io/widget/" + appId) + "\"]");
                if (!intercomLoaded) {
                    var intercomScript = document.createElement("script");
                    intercomScript.type = "text/javascript";
                    if (scriptType) {
                        intercomScript[scriptType] = true;
                    }
                    intercomScript.src = "https://widget.intercom.io/widget/" + appId;
                    var initialScript = document.getElementsByTagName("script")[0];
                    if (initialScript && initialScript.parentNode) {
                        initialScript.parentNode.insertBefore(intercomScript, initialScript);
                    }
                    if (initWindow) {
                        var intercomProps_1 = Object.assign({}, {
                            email: email || null,
                            appId: appId,
                            name: name
                        }, extra);
                        if (delay && typeof delay === "number") {
                            setTimeout(function () { return initIntercomWindow(intercomProps_1); }, delay);
                        }
                        else {
                            initIntercomWindow(intercomProps_1);
                        }
                    }
                }
                else {
                    console.log("intercom script already inserted");
                }
                typeof callBack === "function" && callBack();
            };
            if (scriptInitDelay && typeof scriptInitDelay === "number") {
                setTimeout(loadScript, scriptInitDelay);
            }
            else {
                loadScript();
            }
        }
        else {
            console.warn("intercom failed to load");
        }
    }
}
exports.loadIntercom = loadIntercom;
function initIntercomWindow(_a) {
    var _b = _a.appId, appId = _b === void 0 ? APP_ID : _b, otherProps = __rest(_a, ["appId"]);
    var intercomProps = Object.assign({}, {
        app_id: appId
    }, otherProps);
    if (typeof window !== "undefined" && window.Intercom) {
        if (window.intercomSettings && !window.intercomSettings.app_id) {
            window.intercomSettings = intercomProps;
        }
        window.Intercom("boot", intercomProps);
    }
}
exports.initIntercomWindow = initIntercomWindow;
function shutdownIntercom() {
    if (typeof window !== "undefined" && window.Intercom) {
        window.Intercom("shutdown");
        delete window.Intercom;
        delete window.intercomSettings;
    }
}
exports.shutdownIntercom = shutdownIntercom;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 73241:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employers",
      function () {
        return __webpack_require__(8143);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);





var Button = function(_param) {
    var _type = _param.type, type = _type === void 0 ? "button" : _type, children = _param.children, className = _param.className, onClick = _param.onClick, disabled = _param.disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "type",
        "children",
        "className",
        "onClick",
        "disabled"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        type: type,
        onClick: onClick,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, "bg-gradient-to-bl from-dawnOrange-500 to-dawnPurple-500 rounded-full px-8 md:py-5 text-xs font-medium text-white uppercase", {
            "opacity-40 cursor-not-allowed": disabled
        }),
        disabled: disabled
    }, rest), {
        children: children
    }));
};



/***/ }),

/***/ 23074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41107);



/***/ }),

/***/ 8143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Employers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Navbar/Navbar.tsx + 6 modules
var Navbar = __webpack_require__(92595);
// EXTERNAL MODULE: ./components/Gradient/index.ts + 1 modules
var Gradient = __webpack_require__(1824);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(15445);
;// CONCATENATED MODULE: ./modules/employers/CostOfInsomnia.tsx

var OneInFive = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "177",
        height: "32",
        viewBox: "0 0 177 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.5 28C6.5 28 4.5 28 4.5 26C4.5 24 6.5 18 16.5 18C26.5 18 28.5 24 28.5 26C28.5 28 26.5 28 26.5 28H6.5ZM16.5 16C18.0913 16 19.6174 15.3679 20.7426 14.2426C21.8679 13.1174 22.5 11.5913 22.5 10C22.5 8.4087 21.8679 6.88258 20.7426 5.75736C19.6174 4.63214 18.0913 4 16.5 4C14.9087 4 13.3826 4.63214 12.2574 5.75736C11.1321 6.88258 10.5 8.4087 10.5 10C10.5 11.5913 11.1321 13.1174 12.2574 14.2426C13.3826 15.3679 14.9087 16 16.5 16Z",
                fill: "url(#paint0_linear_1876_1166)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42.509 27C42.505 26.9998 42.497 26.9995 42.4853 26.9986C42.4572 26.9966 42.4105 26.9921 42.3519 26.9824C42.2299 26.962 42.0825 26.9232 41.9472 26.8556C41.8158 26.7899 41.7149 26.7071 41.6446 26.6015C41.5784 26.5023 41.5 26.325 41.5 26C41.5 25.2568 41.9005 23.5137 43.4571 21.9571C44.9844 20.4298 47.7109 19 52.5 19C57.2891 19 60.0156 20.4298 61.5429 21.9571C63.0995 23.5137 63.5 25.2568 63.5 26C63.5 26.325 63.4216 26.5023 63.3554 26.6015C63.2851 26.7071 63.1842 26.7899 63.0528 26.8556C62.9175 26.9232 62.7701 26.962 62.6481 26.9824C62.5895 26.9921 62.5428 26.9966 62.5147 26.9986C62.503 26.9995 62.495 26.9998 62.491 27H42.509ZM56.0355 13.5355C55.0979 14.4732 53.8261 15 52.5 15C51.1739 15 49.9021 14.4732 48.9645 13.5355C48.0268 12.5979 47.5 11.3261 47.5 10C47.5 8.67392 48.0268 7.40215 48.9645 6.46447C49.9021 5.52678 51.1739 5 52.5 5C53.8261 5 55.0979 5.52678 56.0355 6.46447C56.9732 7.40215 57.5 8.67392 57.5 10C57.5 11.3261 56.9732 12.5979 56.0355 13.5355Z",
                stroke: "url(#paint1_linear_1876_1166)",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M78.509 27C78.505 26.9998 78.497 26.9995 78.4853 26.9986C78.4572 26.9966 78.4105 26.9921 78.3519 26.9824C78.2299 26.962 78.0825 26.9232 77.9472 26.8556C77.8158 26.7899 77.7149 26.7071 77.6446 26.6015C77.5784 26.5023 77.5 26.325 77.5 26C77.5 25.2568 77.9005 23.5137 79.4571 21.9571C80.9844 20.4298 83.7109 19 88.5 19C93.2891 19 96.0156 20.4298 97.5429 21.9571C99.0995 23.5137 99.5 25.2568 99.5 26C99.5 26.325 99.4216 26.5023 99.3554 26.6015C99.2851 26.7071 99.1842 26.7899 99.0528 26.8556C98.9175 26.9232 98.7701 26.962 98.6481 26.9824C98.5895 26.9921 98.5428 26.9966 98.5147 26.9986C98.503 26.9995 98.495 26.9998 98.491 27H78.509ZM92.0355 13.5355C91.0979 14.4732 89.8261 15 88.5 15C87.1739 15 85.9021 14.4732 84.9645 13.5355C84.0268 12.5979 83.5 11.3261 83.5 10C83.5 8.67392 84.0268 7.40215 84.9645 6.46447C85.9021 5.52678 87.1739 5 88.5 5C89.8261 5 91.0979 5.52678 92.0355 6.46447C92.9732 7.40215 93.5 8.67392 93.5 10C93.5 11.3261 92.9732 12.5979 92.0355 13.5355Z",
                stroke: "url(#paint2_linear_1876_1166)",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M114.509 27C114.505 26.9998 114.497 26.9995 114.485 26.9986C114.457 26.9966 114.411 26.9921 114.352 26.9824C114.23 26.962 114.082 26.9232 113.947 26.8556C113.816 26.7899 113.715 26.7071 113.645 26.6015C113.578 26.5023 113.5 26.325 113.5 26C113.5 25.2568 113.901 23.5137 115.457 21.9571C116.984 20.4298 119.711 19 124.5 19C129.289 19 132.016 20.4298 133.543 21.9571C135.099 23.5137 135.5 25.2568 135.5 26C135.5 26.325 135.422 26.5023 135.355 26.6015C135.285 26.7071 135.184 26.7899 135.053 26.8556C134.918 26.9232 134.77 26.962 134.648 26.9824C134.589 26.9921 134.543 26.9966 134.515 26.9986C134.503 26.9995 134.495 26.9998 134.491 27H114.509ZM128.036 13.5355C127.098 14.4732 125.826 15 124.5 15C123.174 15 121.902 14.4732 120.964 13.5355C120.027 12.5979 119.5 11.3261 119.5 10C119.5 8.67392 120.027 7.40215 120.964 6.46447C121.902 5.52678 123.174 5 124.5 5C125.826 5 127.098 5.52678 128.036 6.46447C128.973 7.40215 129.5 8.67392 129.5 10C129.5 11.3261 128.973 12.5979 128.036 13.5355Z",
                stroke: "url(#paint3_linear_1876_1166)",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M150.509 27C150.505 26.9998 150.497 26.9995 150.485 26.9986C150.457 26.9966 150.411 26.9921 150.352 26.9824C150.23 26.962 150.082 26.9232 149.947 26.8556C149.816 26.7899 149.715 26.7071 149.645 26.6015C149.578 26.5023 149.5 26.325 149.5 26C149.5 25.2568 149.901 23.5137 151.457 21.9571C152.984 20.4298 155.711 19 160.5 19C165.289 19 168.016 20.4298 169.543 21.9571C171.099 23.5137 171.5 25.2568 171.5 26C171.5 26.325 171.422 26.5023 171.355 26.6015C171.285 26.7071 171.184 26.7899 171.053 26.8556C170.918 26.9232 170.77 26.962 170.648 26.9824C170.589 26.9921 170.543 26.9966 170.515 26.9986C170.503 26.9995 170.495 26.9998 170.491 27H150.509ZM164.036 13.5355C163.098 14.4732 161.826 15 160.5 15C159.174 15 157.902 14.4732 156.964 13.5355C156.027 12.5979 155.5 11.3261 155.5 10C155.5 8.67392 156.027 7.40215 156.964 6.46447C157.902 5.52678 159.174 5 160.5 5C161.826 5 163.098 5.52678 164.036 6.46447C164.973 7.40215 165.5 8.67392 165.5 10C165.5 11.3261 164.973 12.5979 164.036 13.5355Z",
                stroke: "url(#paint4_linear_1876_1166)",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_1876_1166",
                        x1: "28.5",
                        y1: "4",
                        x2: "9.48346",
                        y2: "31.4521",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.0416667",
                                stopColor: "#FF8F5B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.817708",
                                stopColor: "#536DE2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_1876_1166",
                        x1: "64.5",
                        y1: "4",
                        x2: "45.4835",
                        y2: "31.4521",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.0416667",
                                stopColor: "#FF8F5B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.817708",
                                stopColor: "#536DE2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_1876_1166",
                        x1: "100.5",
                        y1: "4",
                        x2: "81.4835",
                        y2: "31.4521",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.0416667",
                                stopColor: "#FF8F5B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.817708",
                                stopColor: "#536DE2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_1876_1166",
                        x1: "136.5",
                        y1: "4",
                        x2: "117.483",
                        y2: "31.4521",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.0416667",
                                stopColor: "#FF8F5B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.817708",
                                stopColor: "#536DE2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_1876_1166",
                        x1: "172.5",
                        y1: "4",
                        x2: "153.483",
                        y2: "31.4521",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.0416667",
                                stopColor: "#FF8F5B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.817708",
                                stopColor: "#536DE2"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function OurScienceBox(param) {
    var icon = param.icon, title = param.title, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center flex-1 px-10 py-8 border border-transparent border-gradient-bl-orange-purple-white md:p-12 xl:p-12 rounded-xl",
        children: [
            icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "font-inter mt-8 text-2xl font-semibold md:mt-6 md:text-4xl",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-base leading-6 xl:text-xl xl:leading-8 text-center font-inter",
                children: text
            })
        ]
    });
}
function CostOfInsomnia() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-xl mx-8 text-center md:text-left flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "w-3/4 md:w-full text-2.5xl leading-8 font-semibold text-center md:text-5xl",
                            children: "How insomnia disrupts the workplace"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-4 text-lg leading-6 text-center md:text-2xl md:leading-10 font-inter",
                            children: "We all know how a bad night of sleep can affect our day. Imagine what a bad night of sleep could do to an entire organization."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt-8 md:mt-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col mx-8 space-y-6 md:flex-row md:space-y-0 md:space-x-8 max-w-6xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OurScienceBox, {
                            icon: OneInFive(),
                            title: "1 in 5",
                            text: "employees experience insomnia regularly."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OurScienceBox, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "41",
                                height: "40",
                                viewBox: "0 0 41 40",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M3.83398 11.6666C3.83398 10.7825 4.18517 9.93468 4.81029 9.30956C5.43542 8.68444 6.28326 8.33325 7.16732 8.33325H33.834C34.718 8.33325 35.5659 8.68444 36.191 9.30956C36.8161 9.93468 37.1673 10.7825 37.1673 11.6666V28.3333C37.1673 29.2173 36.8161 30.0652 36.191 30.6903C35.5659 31.3154 34.718 31.6666 33.834 31.6666H7.16732C6.28326 31.6666 5.43542 31.3154 4.81029 30.6903C4.18517 30.0652 3.83398 29.2173 3.83398 28.3333V11.6666Z",
                                        stroke: "url(#paint0_linear_1876_1181)",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M20.5 25C23.2614 25 25.5 22.7614 25.5 20C25.5 17.2386 23.2614 15 20.5 15C17.7386 15 15.5 17.2386 15.5 20C15.5 22.7614 17.7386 25 20.5 25Z",
                                        stroke: "url(#paint1_linear_1876_1181)",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M3.83398 14.9999C5.60209 14.9999 7.29779 14.2975 8.54803 13.0473C9.79827 11.7971 10.5007 10.1014 10.5007 8.33325M30.5007 31.6666C30.5007 29.8985 31.203 28.2028 32.4533 26.9525C33.7035 25.7023 35.3992 24.9999 37.1673 24.9999",
                                        stroke: "url(#paint2_linear_1876_1181)",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                id: "paint0_linear_1876_1181",
                                                x1: "37.1673",
                                                y1: "8.33325",
                                                x2: "21.6612",
                                                y2: "40.3111",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "0.0416667",
                                                        stopColor: "#FF8F5B"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "0.817708",
                                                        stopColor: "#536DE2"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                id: "paint1_linear_1876_1181",
                                                x1: "25.5",
                                                y1: "15",
                                                x2: "17.5764",
                                                y2: "26.4384",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "0.0416667",
                                                        stopColor: "#FF8F5B"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "0.817708",
                                                        stopColor: "#536DE2"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                id: "paint2_linear_1876_1181",
                                                x1: "37.1673",
                                                y1: "8.33325",
                                                x2: "21.6612",
                                                y2: "40.3111",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "0.0416667",
                                                        stopColor: "#FF8F5B"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "0.817708",
                                                        stopColor: "#536DE2"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            title: "$3,506",
                            text: "lost per year per employee suffering from insomnia"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OurScienceBox, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "41",
                                height: "40",
                                viewBox: "0 0 41 40",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M30.5007 6.6665H10.5007C6.81875 6.6665 3.83398 9.65127 3.83398 13.3332V29.9998C3.83398 33.6817 6.81875 36.6665 10.5007 36.6665H30.5007C34.1826 36.6665 37.1673 33.6817 37.1673 29.9998V13.3332C37.1673 9.65127 34.1826 6.6665 30.5007 6.6665Z",
                                        stroke: "url(#paint0_linear_1876_1190)",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M3.83398 16.6666H37.1673M13.834 3.33325V9.99992V3.33325ZM27.1673 3.33325V9.99992V3.33325Z",
                                        stroke: "url(#paint1_linear_1876_1190)",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                id: "paint0_linear_1876_1190",
                                                x1: "37.1673",
                                                y1: "6.66651",
                                                x2: "14.3691",
                                                y2: "43.2346",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "0.0416667",
                                                        stopColor: "#FF8F5B"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "0.817708",
                                                        stopColor: "#536DE2"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                id: "paint1_linear_1876_1190",
                                                x1: "37.1673",
                                                y1: "3.33325",
                                                x2: "31.3595",
                                                y2: "24.2935",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "0.0416667",
                                                        stopColor: "#FF8F5B"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "0.817708",
                                                        stopColor: "#536DE2"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            title: "11",
                            text: "days of productivity lost per employee per year"
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./components/Button/index.ts
var Button = __webpack_require__(23074);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./node_modules/intercom-next/dist/index.js
var dist = __webpack_require__(53353);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./modules/employers/EmployersForm.tsx










var FORM_STYLE = "rounded-dawnDefault bg-dawnDark-500 bg-opacity-30 w-full px-6 py-4 font-inter border border-dawnDark-400 placeholder-dawnDark-300 text-white text-base xl:text-xl leading-8 focus:outline-none";
var EMAIL_PATTERN = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
function FormItem(param) {
    var label = param.label, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "block pl-1 mb-2 text-base font-normal leading-8 xl:text-xl",
                children: label
            }),
            children
        ]
    });
}
function ErrorLabel(param) {
    var text = param.text, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-2 text-sm font-inter text-dawnRed-500 ".concat(className),
        children: text
    });
}
function EmployersForm() {
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, handleSubmit = ref.handleSubmit, errors = ref.formState.errors, reset = ref.reset;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState("Submit"), 2), signupResult = ref1[0], setSignupResult = ref1[1];
    function submitIntercom(formData) {
        return _submitIntercom.apply(this, arguments);
    }
    function _submitIntercom() {
        _submitIntercom = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(formData) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,dist.loadIntercom)({
                            appId: "nzsfepxr",
                            email: formData.email,
                            name: "".concat(formData.firstName, " ").concat(formData.lastName),
                            numEmployees: formData.numEmployees,
                            companyName: formData.companyName,
                            isEmployer: true
                        });
                    case 2:
                        setSignupResult("Submitted");
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _submitIntercom.apply(this, arguments);
    }
    return signupResult === "Submitted" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "book-a-demo-form",
        className: "md:w-1/2 text-xl text-white bg-white bg-opacity-0.06 p-8 rounded-xl",
        style: {
            height: "fit-content"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "block mb-2 text-2xl font-semibold md:text-4xl md:text-center font-inter md:mb-4",
                children: "Thank You!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "block mb-10 text-base font-inter md:text-xl md:text-center",
                children: "Your form has been submitted! Keep an eye on your inbox for a message from us!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                onClick: function() {
                    reset();
                    setSignupResult("Submit");
                },
                className: "w-full px-8 py-4 text-lg font-medium tracking-widest xl:text-base",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-sm md:text-base",
                    children: "Back to Form"
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        id: "book-a-demo-form",
        onSubmit: handleSubmit(submitIntercom, function(errors) {
            return console.log(errors);
        }),
        className: "md:min-w-[400px] z-10 grid grid-cols-1 gap-4 xl:grid-cols-1 text-white bg-white bg-opacity-6 p-8 rounded-2xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormItem, {
                label: "First name",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        className: FORM_STYLE,
                        placeholder: "John"
                    }, register("firstName", {
                        required: true,
                        pattern: /^[a-z|A-Z|\s]+$/
                    }))),
                    errors.firstName && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLabel, {
                        text: "First name is ".concat(errors.firstName.type === "required" ? "required" : "invalid", ".")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormItem, {
                label: "Last name",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        className: FORM_STYLE,
                        placeholder: "Doe"
                    }, register("lastName", {
                        required: true,
                        pattern: /^[a-z|A-Z|\s]+$/
                    }))),
                    errors.lastName && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLabel, {
                        text: "Last name is ".concat(errors.lastName.type === "required" ? "required" : "invalid", ".")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormItem, {
                label: "Company name",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        className: FORM_STYLE,
                        placeholder: "Dawn Health"
                    }, register("companyName", {
                        required: true,
                        pattern: /^[a-z|A-Z|\s]+$/
                    }))),
                    errors.companyName && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLabel, {
                        text: "Company name is ".concat(errors.companyName.type === "required" ? "required" : "invalid", ".")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormItem, {
                label: "Number of employees",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        className: FORM_STYLE,
                        placeholder: "1-25,000"
                    }, register("numEmployees", {
                        valueAsNumber: true,
                        pattern: /^[0-9|,]+$/
                    }))),
                    errors.numEmployees && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLabel, {
                        text: "Number of employees is ".concat(errors.numEmployees.type === "required" ? "required" : "invalid", ".")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormItem, {
                label: "Email",
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        className: FORM_STYLE,
                        type: "email",
                        placeholder: "you@example.com"
                    }, register("email", {
                        required: true,
                        pattern: EMAIL_PATTERN
                    }))),
                    errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLabel, {
                        text: "Email is ".concat(errors.email.type === "required" ? "required" : "invalid", ".")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-4 text-sm leading-6 text-dawnDark-300",
                children: [
                    "By providing your email, you agree to our",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/legal/privacy-policy",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-dawnOrange-400",
                            children: "Privacy Policy"
                        })
                    }),
                    " ",
                    "and",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/legal/terms-of-service",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-dawnOrange-400",
                            children: "Terms of Service"
                        })
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                className: "w-full px-8 py-4 mt-4 mb-4 text-lg font-medium tracking-widest xl:text-base",
                type: "submit",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-sm md:text-base",
                    children: signupResult
                })
            })
        ]
    });
}
function EmployersFormSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "z-10 flex flex-col justify-between px-8 md:flex-row md:px-24 xl:px-48 max-w-9xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[400px] md:mr-34",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-white mb-4 leading-14 md:leading-18 text-5xl md:text-5.5xl font-semibold",
                        children: "Want to learn more? Get in touch."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-10 text-white font-inter md:text-xl",
                        children: "Better your workplace culture, business outcomes, and sleep."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployersForm, {})
        ]
    });
};

// EXTERNAL MODULE: ./modules/employers/DawnFeatures.tsx + 4 modules
var DawnFeatures = __webpack_require__(34102);
;// CONCATENATED MODULE: ./pages/employers.tsx









function Employers() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Overcome Insomnia With CBT-I & Sleep Coaching \u2014 Sleep App | Dawn Health"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Struggling with insomnia? Ditch the pills and cure your insomnia for good with Dawn's proven online CBT-I app. Let our sleep experts get you back to sleep."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "facebook-domain-verification",
                        content: "lypvevgg0c2g46jzbubi2frb5kd96o"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1.0, width=device-width"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "overflow-x-hidden bg-dawnDark-700",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative hidden md:block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                color: "purple",
                                scale: 7,
                                opacity: 0.25,
                                left: "-50rem"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                color: "orange",
                                scale: 8,
                                opacity: 0.15,
                                left: "-60rem",
                                top: "10rem"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                color: "purple",
                                scale: 7,
                                opacity: 0.25,
                                right: "-30rem",
                                top: "-20rem"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                color: "orange",
                                scale: 7,
                                opacity: 0.1,
                                right: "-40rem",
                                top: "-2rem"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                className: "px-6 text-white md:px-12 pt-22 pb-22 md:py-30",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mx-auto max-w-s md:max-w-3xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "text-5xl md:text-5.5xl leading-14 text-center md:leading-18 font-bold",
                                            children: "Dawn for Enterprise"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center mt-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "max-w-2xl",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-lg leading-6 text-center font-inter md:text-2xl md:leading-10",
                                                    children: [
                                                        "Your employees feel their best with better rest. Dawn is designed to serve everyone\u2019s sleep needs.",
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex justify-center mt-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                        onClick: function() {
                                                            var ref;
                                                            return (ref = document.getElementById("book-a-demo-form")) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                                                                behavior: "smooth",
                                                                block: "center"
                                                            });
                                                        },
                                                        className: "md:py-6 w-full md:w-[261px] px-8 md:px-8 py-4 xl:text-base font-medium tracking-widest",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-sm md:text-base",
                                                            children: "Book a demo"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative z-10 bg-white py-22 md:py-30",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CostOfInsomnia, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative hidden md:block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                        color: "purple",
                                        scale: 7,
                                        opacity: 0.25,
                                        left: "-50rem"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                        color: "orange",
                                        scale: 8,
                                        opacity: 0.15,
                                        left: "-60rem",
                                        top: "10rem"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                        color: "purple",
                                        scale: 7,
                                        opacity: 0.25,
                                        right: "-30rem",
                                        top: "-20rem"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Gradient/* Gradient */.p, {
                                        color: "orange",
                                        scale: 7,
                                        opacity: 0.1,
                                        right: "-40rem",
                                        top: "-2rem"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DawnFeatures/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col items-center pb-22 md:py-36",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployersFormSection, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 6512:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Le; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32984);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12351);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23784);
/* harmony import */ var _hooks_use_id_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19946);
/* harmony import */ var _keyboard_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61363);
/* harmony import */ var _utils_bugs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64103);
/* harmony import */ var _internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16567);
/* harmony import */ var _hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14157);
/* harmony import */ var _utils_owner_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15466);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73781);
var J=(l=>(l[l.Open=0]="Open",l[l.Closed=1]="Closed",l))(J||{}),Q=(t=>(t[t.ToggleDisclosure=0]="ToggleDisclosure",t[t.CloseDisclosure=1]="CloseDisclosure",t[t.SetButtonId=2]="SetButtonId",t[t.SetPanelId=3]="SetPanelId",t[t.LinkPanel=4]="LinkPanel",t[t.UnlinkPanel=5]="UnlinkPanel",t))(Q||{});let V={[0]:e=>({...e,disclosureState:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(e.disclosureState,{[0]:1,[1]:0})}),[1]:e=>e.disclosureState===1?e:{...e,disclosureState:1},[4](e){return e.linkedPanel===!0?e:{...e,linkedPanel:!0}},[5](e){return e.linkedPanel===!1?e:{...e,linkedPanel:!1}},[2](e,n){return e.buttonId===n.buttonId?e:{...e,buttonId:n.buttonId}},[3](e,n){return e.panelId===n.panelId?e:{...e,panelId:n.panelId}}},B=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);B.displayName="DisclosureContext";function v(e){let n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(B);if(n===null){let l=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(l,v),l}return n}let h=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);h.displayName="DisclosureAPIContext";function K(e){let n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h);if(n===null){let l=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(l,K),l}return n}let H=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);H.displayName="DisclosurePanelContext";function X(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(H)}function Y(e,n){return (0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(n.type,V,e,n)}let Z=react__WEBPACK_IMPORTED_MODULE_0__.Fragment,ee=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(n,l){let{defaultOpen:y=!1,...u}=n,T=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),t=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .useSyncRefs */ .T)(l,(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .optionalRef */ .h)(a=>{T.current=a},n.as===void 0||n.as===react__WEBPACK_IMPORTED_MODULE_0__.Fragment)),o=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),f=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),s=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(Y,{disclosureState:y?0:1,linkedPanel:!1,buttonRef:f,panelRef:o,buttonId:null,panelId:null}),[{disclosureState:i,buttonId:p},D]=s,d=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(a=>{D({type:1});let r=(0,_utils_owner_js__WEBPACK_IMPORTED_MODULE_5__/* .getOwnerDocument */ .r)(T);if(!r||!p)return;let c=(()=>a?a instanceof HTMLElement?a:a.current instanceof HTMLElement?a.current:r.getElementById(p):r.getElementById(p))();c==null||c.focus()}),P=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({close:d}),[d]),A=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:i===0,close:d}),[i,d]),S={ref:t};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(B.Provider,{value:s},react__WEBPACK_IMPORTED_MODULE_0__.createElement(h.Provider,{value:P},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .OpenClosedProvider */ .up,{value:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(i,{[0]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .State.Open */ .ZM.Open,[1]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .State.Closed */ .ZM.Closed})},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:S,theirProps:u,slot:A,defaultTag:Z,name:"Disclosure"}))))}),te="button",ne=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(n,l){let y=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_7__/* .useId */ .M)(),{id:u=`headlessui-disclosure-button-${y}`,...T}=n,[t,o]=v("Disclosure.Button"),f=X(),s=f===null?!1:f===t.panelId,i=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),p=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .useSyncRefs */ .T)(i,l,s?null:t.buttonRef);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{if(!s)return o({type:2,buttonId:u}),()=>{o({type:2,buttonId:null})}},[u,o,s]);let D=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(r=>{var c;if(s){if(t.disclosureState===1)return;switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Enter */ .R.Enter:r.preventDefault(),r.stopPropagation(),o({type:0}),(c=t.buttonRef.current)==null||c.focus();break}}else switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Enter */ .R.Enter:r.preventDefault(),r.stopPropagation(),o({type:0});break}}),d=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(r=>{switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:r.preventDefault();break}}),P=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(r=>{var c;(0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_9__/* .isDisabledReactIssue7711 */ .P)(r.currentTarget)||n.disabled||(s?(o({type:0}),(c=t.buttonRef.current)==null||c.focus()):o({type:0}))}),A=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t.disclosureState===0}),[t]),S=(0,_hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_10__/* .useResolveButtonType */ .f)(n,i),a=s?{ref:p,type:S,onKeyDown:D,onClick:P}:{ref:p,id:u,type:S,"aria-expanded":n.disabled?void 0:t.disclosureState===0,"aria-controls":t.linkedPanel?t.panelId:void 0,onKeyDown:D,onKeyUp:d,onClick:P};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:a,theirProps:T,slot:A,defaultTag:te,name:"Disclosure.Button"})}),le="div",re=_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.Static */ .AN.Static,oe=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(n,l){let y=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_7__/* .useId */ .M)(),{id:u=`headlessui-disclosure-panel-${y}`,...T}=n,[t,o]=v("Disclosure.Panel"),{close:f}=K("Disclosure.Panel"),s=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .useSyncRefs */ .T)(l,t.panelRef,P=>{o({type:P?4:5})});(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(o({type:3,panelId:u}),()=>{o({type:3,panelId:null})}),[u,o]);let i=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .useOpenClosed */ .oJ)(),p=(()=>i!==null?i===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .State.Open */ .ZM.Open:t.disclosureState===0)(),D=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t.disclosureState===0,close:f}),[t,f]),d={ref:s,id:u};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(H.Provider,{value:t.panelId},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:d,theirProps:T,slot:D,defaultTag:le,features:re,visible:p,name:"Disclosure.Panel"}))}),Le=Object.assign(ee,{Button:ne,Panel:oe});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9122,5329,5430,1421,1934,2595,3704,9774,2888,179], function() { return __webpack_exec__(73241); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);